import React from 'react';
import {CAlert} from '@coreui/react';
import {isArray} from 'lodash';
import {v4 as uuidv4} from 'uuid';

const key = uuidv4();
let count = 0;

const PAlertErrors = (props: any) => {
  const {errors, fieldName} = props;

  // If fieldName is provided, only show errors for that specific field
  // Don't fall back to showing all errors
  if (fieldName) {
    const fieldError = errors && errors[fieldName];
    if (!fieldError) {
      return <></>;
    }

    let errorList = isArray(fieldError) ? fieldError : [fieldError];

    return (
      <div key={key} className="mb-2">
        {errorList.map((error: any) => {
          const errorMessage = typeof error === 'string' ? error : (typeof error === 'object' ? JSON.stringify(error) : String(error));
          return (
            <div key={`${key}-00${count++}`} className="custom-invalid-field-feedback">
              {errorMessage}
            </div>
          );
        })}
      </div>
    );
  }

  // No fieldName provided - show all errors from the errors object
  let errorList = errors;

  // Handle null/undefined
  if (!errorList) {
    return <></>;
  }

  // Handle empty objects
  if (!isArray(errorList) && typeof errorList === 'object' && Object.keys(errorList).length === 0) {
    return <></>;
  }

  // If errorList is an object with error properties (like {missingFieldsError: "..."}), extract the values
  if (!isArray(errorList) && typeof errorList === 'object') {
    errorList = Object.values(errorList);
  }

  if (!isArray(errorList)) {
    errorList = [errorList];
  }

  if (errorList && errorList.length > 0) {
    return (
      <div key={key} className="mb-2">
        {errorList.map((error: any) => {
          // Ensure error is a string before rendering
          const errorMessage = typeof error === 'string' ? error : (typeof error === 'object' ? JSON.stringify(error) : String(error));
          return (
            <div key={`${key}-00${count++}`} className="custom-invalid-field-feedback">
              {errorMessage}
            </div>
          );
        })}
      </div>
    );
  } else {
    return <div></div>;
  }
};
export default PAlertErrors;
